exports.components = {
  "component---shared-plugins-gatsby-source-dek-wp-pages-index-js": () => import("./../../../../shared/plugins/gatsby-source-dek-wp/pages/index.js" /* webpackChunkName: "component---shared-plugins-gatsby-source-dek-wp-pages-index-js" */)
}

